import styled from "@emotion/styled";
import {
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
} from "@gumtree/ui-library/src/base/theme";

export const FiltersContainer = styled.div`
    height: fit-content;
    width: 232px;
    min-width: 232px;
    border-radius: ${gutterSizes.base};
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
    padding: ${gutterSizes.large} ${gutterSizes.large} ${gutterSizes.xlarge};
`;

export const StyledFilterTypeTitle = styled.div`
    font-size: ${fontSizes.header};
    font-weight: ${fontWeights.bold};
    line-height: ${lineHeights.medium};
    margin-bottom: ${gutterSizes.large};
`;

export const OtherFiltersContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-top: 1px solid ${colors.bark20};
    padding-top: ${gutterSizes.xlarge};
    margin-top: ${gutterSizes.large};
    grid-gap: ${gutterSizes.large};
`;
